import { type JSX } from 'react/jsx-runtime';

export const BROWSE_AGENTS_DARK = (): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 275 275" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="55" y="55" width="165" height="165" rx="24" fill="#AF59E0" />
		<rect
			x="55"
			y="55"
			width="165"
			height="165"
			rx="24"
			stroke="#1558BC"
			strokeWidth="12"
			fillRule="evenodd"
			clipRule="evenodd"
		/>
		<path d="M137.5 90 L137.5 185" stroke="#E2E3E4" strokeWidth="16" strokeLinecap="round" />
		<path d="M90 137.5 L185 137.5" stroke="#E2E3E4" strokeWidth="16" strokeLinecap="round" />
	</svg>
);
